
<template>
<!-- 转办人 -->
  <el-dialog
      center
      top="20%"
      :visible.sync="transferDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      :before-close="clear"
    >
      <el-form :model="demandStaff" :rules="rules" ref="demandStaffRef">
        <el-form-item label="审核人员" prop="name">
          <el-select
            v-model="demandStaff.name"
            clearable
            filterable
            size="mini"
            placeholder="请选择"
          >
            <el-option
              v-for="item in purchaserCheckData"
              :key="item.account"
              :value="item.id"
              :label="item.loginName"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clear">取消</el-button>
        <el-button type="primary" @click="transferSaveBtn">确认</el-button>
      </div>
    </el-dialog>
</template>
<script>
export default {
  props: {
    url: String,
    transferList: Array
  },
  data() {
    return {
      transferDialogVisible: false,
      demandStaff: {name: ''},
      purchaserCheckData: [],
      rules: {name: [{ required: true, message: '请选择采购审核', trigger: 'change' }]}
    };
  },
  created() {
    const params = {
      customerId: '0'
    };
    this.$http.setting.getUserListBuyer(params).then(res => {
      this.purchaserCheckData = res.data;
    });
  },
  methods: {
    open() {
      this.transferDialogVisible= true
      this.$nextTick(() => {
        this.$refs.demandStaffRef.clearValidate()
      })
    },
    transferSaveBtn() {
      this.$refs.demandStaffRef.validate(val => {
        if (!val) return false;
        const params = this.transferList.map(item => {
          return {
            purchaserCheck: this.demandStaff.name,
            id: item.id
          }
        });
        this.$http.outsideSampleManage[this.url](params)
          .then(() => {
           this.clear()
            this.$message.success('转办成功');
            this.$emit('saveBtn')
          })
          .catch(err => {
            this.$message.error(err.msg);
          });
      });
    },
    clear() {
      for (let key in this.demandStaff) {
        this.demandStaff[key] = undefined;
      }
      this.transferDialogVisible = false;
    },
  },
};
</script>
